import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../../libs'
import {
  PartnerClient,
  PartnerClientRequest,
  PartnerClientResponse,
} from './types'
import { $params } from 'src/features/router'
import {
  changedDateFormat,
  isAllElementsOfSearchTextNotExist,
} from '../../../../../libs/utils'

const DATE_FIELDS = ['attachedAt']

const KEY_MAP: Record<string, string> = {
  transactionId: 'id',
}

const mapSearchEntry = (key: string, value: any): [string, any] => {
  const mappedKey = KEY_MAP[key] ?? key

  if (DATE_FIELDS.includes(key)) {
    const dates = Array.isArray(value)
      ? value.map((date) => {
          if (!date) return `${date}`
          if (date?.$d) return changedDateFormat(date.$d)
          return date
        })
      : value
    return [mappedKey, dates]
  }

  return [mappedKey, value?.toLowerCase()]
}

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map(([key, value]) =>
      mapSearchEntry(key, value),
    ),
  )
}

export const partnerClientsListMounted = createEvent<PartnerClientRequest>()

export const getPartnerClients = fx<
  PartnerClientRequest,
  PartnerClientResponse
>({
  method: 'GET',
  url: `/partner/{id}/client`,
})

export const $partnerClients = restore<PartnerClient[]>(
  getPartnerClients.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfPartnerClients = restore(
  getPartnerClients.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: partnerClientsListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    let query = {
      limit,
      page,
    }

    if (orderBy != '') {
      if (orderBy.constructor === Array) {
        // @ts-ignore
        orderBy = orderBy.join('.')
      }
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }
    let newObj = {}
    // // @ts-ignore
    // newObj['partnerId'] = $params.getState().partnerID
    // // @ts-ignore
    // query['where'] = `${JSON.stringify(newObj)}`
    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      const newFilters = {
        ...filters,
        status: filters.status?.map((item) => `${item}`),
      }

      const CLIENT_PREFIX_KEYS = ['country', 'verified', 'hasDeposit']
      newObj = Object.keys(newFilters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          const apiKey = CLIENT_PREFIX_KEYS.includes(key) ? `client.${key}` : key
          const value = filters[key as keyof typeof filters]
          accumulator[apiKey] = Array.isArray(value) ? value : `${value}`
        }
        return accumulator
      }, {} as any)

      if (searchText && !isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }
      // @ts-ignore
      newObj['partnerId'] = $params.getState().partnerID
      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    let url = `/partner/${$params.getState()?.partnerID}/client`
    return {
      query,
      url,
    }
  },
  target: getPartnerClients,
})
